import React, { useId, useState } from 'react';
import { OIL_SP500_INTRO, REGIME_MATRIX } from '../utils/oilSp500Signal';

function OilSp500Help() {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div className="oil-sp500-help">
      <button
        type="button"
        className="oil-sp500-help-trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        How to read this
      </button>
      {open && (
        <div id={panelId} className="oil-sp500-help-panel" role="region" aria-label="Oil vs S&P guide">
          <p className="oil-sp500-help-body">{OIL_SP500_INTRO}</p>
          <table className="oil-sp500-regime-table">
            <thead>
              <tr>
                <th>90d correlation</th>
                <th>Oil up (3m)</th>
                <th>Oil down (3m)</th>
              </tr>
            </thead>
            <tbody>
              {REGIME_MATRIX.map((row) => (
                <tr key={row.corrBand}>
                  <td>{row.corrBand}</td>
                  <td>
                    {row.oilUp.emoji} {row.oilUp.label}
                    <span className="oil-sp500-cell-note"> — {row.oilUp.tooltip}</span>
                  </td>
                  <td>
                    {row.oilDown.emoji} {row.oilDown.label}
                    <span className="oil-sp500-cell-note"> — {row.oilDown.tooltip}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="oil-sp500-help-note">
            Default oil leg is Brent futures (BZ=F, USD). BRNT ETC tracks rolled futures (roll yield)
            and is EUR-listed — use only with that caveat. Align on common US equity sessions; daily log
            returns; 30/60/90-day correlation windows.
          </p>
        </div>
      )}
    </div>
  );
}

export default OilSp500Help;
